import { Injectable } from '@angular/core';
import { AppConstant } from '@app/app.constant';
import { GlobalService } from '@core/services/global.service';
import { LocalStorageService } from '@core/services/local-storage.service';

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    constructor(private globalService: GlobalService) {

    }

    get isLoggedIn() {
        return LocalStorageService.getLogInStatus() && LocalStorageService.getAccessToken();
    }

    get userInfo() {
        return LocalStorageService.getUserInfo();
    }

    setUserInfo(data) {
        LocalStorageService.setUserInfo(data);
    }

    setLoggedIn(data) {
        LocalStorageService.setLogInStatus(true);
        LocalStorageService.setAccessToken(data.accessToken);
        LocalStorageService.setRefreshToken(data.refreshToken);
        this.globalService.storage.dispatch(AppConstant.GLOBAL_STORAGE.TOKEN, data.accessToken);
        this.globalService.storage.dispatch(AppConstant.GLOBAL_STORAGE.REFRESH_TOKEN, data.refreshToken);
    }

    logout() {
        // LocalStorageService.clear();
        LocalStorageService.removeItem(AppConstant.LOCAL_STORAGE_KEYS.TOKEN);
        LocalStorageService.removeItem(AppConstant.LOCAL_STORAGE_KEYS.REFRESH_TOKEN);
        LocalStorageService.removeItem(AppConstant.LOCAL_STORAGE_KEYS.LOGIN_STATUS);
        this.globalService.storage.dispatch(AppConstant.GLOBAL_STORAGE.TOKEN, null);
        this.globalService.storage.dispatch(AppConstant.GLOBAL_STORAGE.BUSINESS_UNITS, null);
        this.globalService.storage.dispatch(AppConstant.GLOBAL_STORAGE.ORGANIZATION, null);
        this.globalService.storage.dispatch(AppConstant.GLOBAL_STORAGE.GROUPS_PERMISSIONS, null);
    }
}
